import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

interface FileInputWrapperStyledProps {
  isDragging?: boolean;
  disabled?: boolean;
}

export const FileInputWrapperStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isDragging' && prop !== 'disabled',
})<FileInputWrapperStyledProps>(({ isDragging, disabled }) => ({
  border: isDragging ? '2px dashed #1976d2' : `1px solid ${grey[300]}`,
  backgroundColor: isDragging ? 'rgba(25, 118, 210, 0.08)' : grey[50],
  width: '100%',
  display: 'flex',
  cursor: disabled ? 'not-allowed' : 'pointer',
  height: '52px',
  opacity: disabled ? 0.5 : 1,
  transition: 'all 0.2s ease-in-out',

  '&:hover': disabled
    ? {}
    : {
        borderColor: grey[400],
        backgroundColor: grey[100],
      },
}));
